import { render, staticRenderFns } from "./BusinessOrdersFile.vue?vue&type=template&id=627aba38&scoped=true&"
import script from "./BusinessOrdersFile.vue?vue&type=script&lang=js&"
export * from "./BusinessOrdersFile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOrdersFile.vue?vue&type=style&index=0&id=627aba38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627aba38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627aba38')) {
      api.createRecord('627aba38', component.options)
    } else {
      api.reload('627aba38', component.options)
    }
    module.hot.accept("./BusinessOrdersFile.vue?vue&type=template&id=627aba38&scoped=true&", function () {
      api.rerender('627aba38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business-orders/BusinessOrdersFile.vue"
export default component.exports